import { DRUCKPFAHL, ZUGPFAHL } from "../../../constants";
import {
  GermanyAussereDruckNachweisGruppe,
  GermanyAussereZugNachweisGruppe,
} from "./GermanyAussereDruckNachweisGruppe";
import { GermanyAussereDruckNachweisUebertragungslaenge } from "./GermanyAussereDruckNachweisUebertragungslaenge";
import { GermanyAussereZugNachweisUebertragungslaenge } from "./GermanyAussereZugNachweisUebertragungslaenge";
import { GermanyAussereDruck } from "./GermanyAussereDruck";

export function GermanyAussere({ data }) {
  let belastungsartUndRichtung =
    data?.Germany?.Innere?.BeanspruchungausStatik?.belastungsartUndRichtung ?? false;
  let kompressionspfahlgruppenCheckbox =
    data?.FrontendZustand?.kompressionspfahlgruppenCheckbox ?? false;
  let uebertragungslaengeCheckbox = data?.FrontendZustand?.uebertragungslaengeCheckbox ?? false;
  let ueberpruefungVonPfahlgruppenCheckbox =
    data?.FrontendZustand?.ueberpruefungVonPfahlgruppenCheckbox === true ?? false;

  return (
    <>
      <GermanyAussereDruck data={data} />

      {belastungsartUndRichtung === DRUCKPFAHL ? (
        <>
          {kompressionspfahlgruppenCheckbox === true ? (
            <GermanyAussereDruckNachweisGruppe data={data} />
          ) : null}
          {uebertragungslaengeCheckbox === true ? (
            <GermanyAussereDruckNachweisUebertragungslaenge data={data} />
          ) : null}
        </>
      ) : null}

      {belastungsartUndRichtung === ZUGPFAHL ? (
        <>
          {ueberpruefungVonPfahlgruppenCheckbox === true ? (
            <GermanyAussereZugNachweisGruppe data={data} />
          ) : null}
          {uebertragungslaengeCheckbox === true ? (
            <GermanyAussereZugNachweisUebertragungslaenge data={data} />
          ) : null}
        </>
      ) : null}
    </>
  );
}
